import React, { useState, useEffect } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'
import { IoMdGift } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import http from '../../config/BaseUrl';
import Layout from '../../components/layouts/Layout';
import NewFormWizard from '../../components/formWizard/NewFormWizard';
import NewFormWizardChild from '../../components/formWizard/FormWizardChild';
import { LoadingSpinner } from '../../components/Loader/Loader';
import IncentiveFormItem from '../events/createEvent/createEventChild/module/incentiveOffer/IncentiveFormItem';

const IncentiveOfferEdit = () => {

    const history = useHistory();
    const { id } = useParams();
    const IncentiveOffers = history.location.state.IncentiveOffer
    const incentiveDetails = history.location.state.incentiveDetails
    const [loading, setLoading] = useState(false)
    const [draftLoading, setDraftLoading] = useState(false)
    const [incentive, setIncentive] = useState([])

    const htmlAttributes = { placeholder: "Expiry date" };
    const { event_option, eventId } = useSelector(state => state.createEvent)

    const { register, handleSubmit, formState: { errors }, control, reset } = useForm({
        mode: "all",
        reValidateMode: "onChange",
        defaultValues: {
            description: incentiveDetails ? incentiveDetails.description : '',
            incentive_offer: IncentiveOffers
        }
    })
    const { fields, append, remove, prepend } = useFieldArray({ control, name: "incentive_offer" })


    const appendForm = () => {
        let totalFields = 12
        let currentFields = fields.length
        let extededItem = totalFields - currentFields
        if (currentFields < totalFields) {
            if (extededItem > 3) {
                for (let i = 0; i < 3; i++) {
                    append({ offer_name: "", uses_limit: "", expire_in: "" })
                }
            }
            else {
                for (let i = 0; i < extededItem; i++) {
                    append({ offer_name: "", uses_limit: "", expire_in: "" })
                }
            }
        }
    }


    const fetchEditData = async () => {
        try {
            setLoading(true)
            await http.get(`incentive-offer/${id}`)
                .then((res) => {
                    if (res.data) {
                        setIncentive(res.data.incentive_offer)
                        reset({ incentive_offer: res.data.incentive_offer })
                        setLoading(false)
                    }
                }).catch((err) => {
                    console.log(err);
                    setLoading(false)
                })
        } catch (error) {

        }
    }

    useEffect(() => {
        fetchEditData()
    }, [])

    const onSubmitUpdate = async (data) => {
        let offer = {
            eventId: id,
            incentive_offer: data.incentive_offer,
            description: data.description
        }

        try {
            setLoading(true)
            await http.post(`incentive-offer/update/${id}`, offer).then((res) => {
                if (res.data) {
                    setLoading(false)
                    history.push(`/show/event/${id}`, 'Information Updated.')
                }
            }).catch((err) => {
                setLoading(false)
                console.log(err);
            })
        } catch (error) {
            setLoading(false)
        }
    };



    return (
        <Layout>
            <NewFormWizard />
            <NewFormWizardChild />
            <section className="mt-4">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="text-center col-12 col-md-12">
                                        <div className="">
                                            <p className="mb-0 display-4 text-primary event-form-title">Incentives & Offers </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <form onSubmit={handleSubmit(onSubmitUpdate)}>
                    <div className="mt-2 mb-3 row justify-content-center">
                        <div className="col-md-10">
                            <div className="p-4 bg-white border d-flex flex-column radius-10 ">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <IoMdGift size={30} />
                                        <p className="mb-0 ml-2 font-size-16">Incentives & Offers</p>
                                    </div>
                                    <div className="float-right">
                                        <button
                                            type="button"
                                            className="mr-3 btn btn-outline-primary"
                                            onClick={appendForm}
                                        >ADD</button>

                                    </div>
                                </div>

                                <div className="offer-description mt-3 pt-3 border-top">
                                    <div className="form-group mb-0">
                                        <textarea
                                            className="form-control"
                                            placeholder="Write the promotional message here to attract your customers"
                                            rows="6"
                                            {...register('description', { required: "This is required." })}>
                                        </textarea>
                                    </div>
                                </div>

                                <div className="prop__area">
                                    <div>
                                        {fields.map((item, index) => {
                                            return (
                                                <IncentiveFormItem
                                                    key={`offer-form-${index}`}
                                                    idx={index} 
                                                    register={register} 
                                                    errors={errors} 
                                                    control={control}
                                                    remove={remove} 
                                                    offerData={IncentiveOffers[index]} />
                                            )
                                        })}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            <button type="submit" className="float-right px-5 btn btn-primary radius-10">
                                {loading ?
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Updating...
                                    </>
                                    : "Update"
                                }
                            </button>
                        </div>
                    </div>
                </form>
            </section>
        </Layout>
    )
}

export default IncentiveOfferEdit
